<template>
  <!-- 健康人页面 -->
  <div class="begin">
    <div class="health">
      <div class="search">
        <van-search
          v-model="searchvalue"
          show-action
          placeholder="请输入搜索关键词"
          @search="onSearch"
        >
          <template #action>
            <div @click="onSearch" style="font-size: 14px;">搜索</div>
          </template>
        </van-search>
      </div>
    </div>
<!--    <div class="swipe">-->
<!--      <van-swipe class="my-swipe" style="height: 150px;" :autoplay="3000" indicator-color="white">-->
<!--        <van-swipe-item v-for="(item,index) in data" :key="index">-->
<!--          <img style="width: 100%;height: 100%;" v-lazy="item.image.preview_url"/>-->
<!--        </van-swipe-item>-->
<!--      </van-swipe>-->
<!--    </div>-->
    <!-- 查询条件组件 -->
<!--    <van-sticky class="sticky1" >-->
<!--      <div class="zhineng">-->
<!--        <div class="beginzhineng">-->
<!--          <div @click="getflist">智能推荐</div>-->
<!--          &lt;!&ndash; 智能推荐组件弹窗 &ndash;&gt;-->
<!--          <van-action-sheet v-model="show1" class="citychange" title="智能推荐">-->
<!--            <div class="quyu">当前距您最近的区域是</div>-->
<!--            <div class="quyucontent" style="margin-bottom: 20px;">-->
<!--              <div class="cityconpos">-->
<!--                <div class="citycon">-->
<!--                  <div class="citypos" v-for="(item,index) in flist" :key="index">-->
<!--                    <div :style="cityold === item.name ? 'color:#57CAC6;' : '' " @click="setCity(item.name)" >{{item.name}}</div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </van-action-sheet>-->
<!--          &lt;!&ndash;          <div @click="show1 = true">智能推荐</div>&ndash;&gt;-->
<!--          &lt;!&ndash;          &lt;!&ndash; 智能推荐组件弹窗 &ndash;&gt;&ndash;&gt;-->
<!--          &lt;!&ndash;          <van-action-sheet v-model="show1" class="citychange" title="智能推荐">&ndash;&gt;-->
<!--          &lt;!&ndash;            <div class="quyu">当前距您最近的区域是</div>&ndash;&gt;-->
<!--          &lt;!&ndash;            <div class="quyucontent">&ndash;&gt;-->
<!--          &lt;!&ndash;              <div class="cityconpos">&ndash;&gt;-->
<!--          &lt;!&ndash;                <div class="citycon">&ndash;&gt;-->
<!--          &lt;!&ndash;                  <div class="citypos" v-for="(item,index) in 6" :key="index">&ndash;&gt;-->
<!--          &lt;!&ndash;                    <div class="city1">&ndash;&gt;-->
<!--          &lt;!&ndash;                      <van-image&ndash;&gt;-->
<!--          &lt;!&ndash;                        round&ndash;&gt;-->
<!--          &lt;!&ndash;                        width="50"&ndash;&gt;-->
<!--          &lt;!&ndash;                        height="50"&ndash;&gt;-->
<!--          &lt;!&ndash;                        :src="require('../assets/images/haerbin.png')"&ndash;&gt;-->
<!--          &lt;!&ndash;                      />&ndash;&gt;-->
<!--          &lt;!&ndash;                    </div>&ndash;&gt;-->
<!--          &lt;!&ndash;                    <div>哈尔滨</div>&ndash;&gt;-->
<!--          &lt;!&ndash;                  </div>&ndash;&gt;-->
<!--          &lt;!&ndash;                </div>&ndash;&gt;-->
<!--          &lt;!&ndash;                <div class="confirmBtn">&ndash;&gt;-->
<!--          &lt;!&ndash;                  <van-button type="primary" size="large" round>确认</van-button>&ndash;&gt;-->
<!--          &lt;!&ndash;                </div>&ndash;&gt;-->
<!--          &lt;!&ndash;                <div class="confirmBtn1">&ndash;&gt;-->
<!--          &lt;!&ndash;                  <van-button plain size="large" round>取消</van-button>&ndash;&gt;-->
<!--          &lt;!&ndash;                </div>&ndash;&gt;-->
<!--          &lt;!&ndash;              </div>&ndash;&gt;-->
<!--          &lt;!&ndash;            </div>&ndash;&gt;-->
<!--          &lt;!&ndash;          </van-action-sheet>&ndash;&gt;-->
<!--          <div @click="show2 = true">城市推荐</div>-->
<!--          &lt;!&ndash; 城市定位组件弹窗 &ndash;&gt;-->

<!--          <van-action-sheet style="min-height: 80%"  class="citychange" v-model="show2" title="城市推荐">-->
<!--            <div class="quyu">当前城市定位</div>-->
<!--            <div style="margin-left: 20px;margin-right: 20px;display: flex;justify-content: space-between;">-->
<!--              <div class="citypos1" style="height: 32px;">-->
<!--                <div :class="cityold === city && cityold !== null ? 'acbutton' : 'dfbutton'" @click="setCity(city)"-->
<!--                     type="primary" round>-->
<!--                  {{ city ? city : '未知' }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div @click="getCity" class="location" style="line-height: 32px;">-->
<!--                <van-icon class="iconfont wuyou-shijuedingwei_o"/>-->
<!--                重新定位-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="hotcity" style="margin-left: 20px;margin-right: 20px;margin-top:8px;">当前可选热门城市</div>-->
<!--            <div class="citycon1"-->
<!--                 style="margin-left: 20px;margin-right: 20px;display: flex;justify-content:flex-start;line-height: 32px;">-->
<!--              <div class="citypos2" v-for="item in cityList" key="index"-->
<!--                   style="margin-top: 0px;margin-bottom: 10px; margin-right: 15px;">-->
<!--                <div-->
<!--                  :class="cityold === item.name ? 'acbutton' : cityold ==='' && item.name == '全国' ? 'acbutton' : 'dfbutton'"-->
<!--                  type="primary" @click="setCity(item.name)" round>{{ item.name }}-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="hotcity" style="margin-left: 20px;margin-right: 20px;margin-top:8px;">全国城市</div>-->
<!--            <div style="position: relative;margin-left:10px;margin-bottom: 10px;">-->
<!--              <van-index-bar :sticky="false">-->
<!--                <van-index-anchor v-for="(item,name) in allcity" :key="name" :index="name">-->
<!--                  <b>{{ name }}</b>-->
<!--                  <div :style="cityold === e.name ? 'color:#57CAC6;' : '' " @click="setCity(e.name)"-->
<!--                       v-for="(e,i) in item">{{ e.name }}-->
<!--                  </div>-->
<!--                </van-index-anchor>-->
<!--              </van-index-bar>-->
<!--            </div>-->
<!--            &lt;!&ndash;            <div class="quyu">当前城市定位</div>&ndash;&gt;-->
<!--            &lt;!&ndash;            <div class="quyucontent">&ndash;&gt;-->
<!--            &lt;!&ndash;              <div class="cityconpos">&ndash;&gt;-->
<!--            &lt;!&ndash;                <div class="citycon1">&ndash;&gt;-->
<!--            &lt;!&ndash;                  <div class="citypos1">&ndash;&gt;-->
<!--            &lt;!&ndash;                    <van-button style="padding: 0 20px;" @click="setCity(city)" plain type="primary" size="normal" round>{{city?city:'未知'}}</van-button>&ndash;&gt;-->
<!--            &lt;!&ndash;                  </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                  <div @click="getCity" class="location">&ndash;&gt;-->
<!--            &lt;!&ndash;                    <van-icon  class="iconfont wuyou-shijuedingwei_o"/>&ndash;&gt;-->
<!--            &lt;!&ndash;                    重新定位&ndash;&gt;-->
<!--            &lt;!&ndash;                  </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div class="hotcity">当前可选热门城市</div>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div class="citycon1">&ndash;&gt;-->
<!--            &lt;!&ndash;                  <div class="citypos2" v-for="item in cityList" key="index">&ndash;&gt;-->
<!--            &lt;!&ndash;                    <van-button style="padding: 0 20px;" plain type="primary" @click="setCity(item.name)" size="normal" round>{{item.name}}</van-button>&ndash;&gt;-->
<!--            &lt;!&ndash;                  </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div class="quanguo">&ndash;&gt;-->
<!--            &lt;!&ndash;                  <van-index-bar :sticky="false">&ndash;&gt;-->
<!--            &lt;!&ndash;                    <van-index-anchor v-for="(item,name) in allcity" :key="name" :index="name" >&ndash;&gt;-->
<!--            &lt;!&ndash;                      <b>{{name}}</b>&ndash;&gt;-->
<!--            &lt;!&ndash;                      <van-cell @click="setCity(e.name)" v-for="(e,i) in item" :title="e.name" />&ndash;&gt;-->
<!--            &lt;!&ndash;                    </van-index-anchor>&ndash;&gt;-->
<!--            &lt;!&ndash;                  </van-index-bar>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;              </div>&ndash;&gt;-->
<!--            &lt;!&ndash;            </div>&ndash;&gt;-->
<!--          </van-action-sheet>-->
<!--          <div @click="show3 = true">体检难度</div>-->
<!--          &lt;!&ndash; 体检难度组件弹窗 &ndash;&gt;-->
<!--          <van-action-sheet class="citychange" v-model="show3" title="体检难度">-->
<!--            <div class="quyu">选择体检难度</div>-->
<!--            <div class="quyucontent">-->
<!--              <div class="cityconpos">-->
<!--                <div class="citycon1">-->
<!--                  <div class="buxian">-->
<!--                    <div :class="tijian === '' ? 'acbutton' : 'dfbutton'" @click="settijian('')" type="primary" round>不-->
<!--                      限-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="hotcity">选择难度</div>-->
<!--                <div class="citycon1" style="margin-bottom: 20px;">-->
<!--                  <van-rate v-model="tijian" @change="settijian(tijian)" size="25"/>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </van-action-sheet>-->
<!--          <div @click="setsrot">-->
<!--            营养费-->
<!--            <van-icon color="#57CAC6" :name="sortPrice?'descending':'ascending'"/>-->
<!--          </div>-->
<!--          <div @click="show4 = true">筛选条件</div>-->
<!--          <van-action-sheet class="citychange" v-model="show4" title="筛选条件">-->
<!--            <div class="quyu">价格</div>-->
<!--            <div class="quyucontent">-->
<!--              <div class="cityconpos">-->
<!--                <div class="citycon1">-->
<!--                  <div class="buxian" style="display: flex;justify-content:flex-start;width: 100%;">-->
<!--                    <div style="margin-right: 10px;" @click="setjiage('')"-->
<!--                         :class="jiage === '' ? 'acbutton' : 'dfbutton' " type="primary" round>不 限-->
<!--                    </div>-->
<!--                    <div style="margin-right: 10px;" @click="setjiage(true)"-->
<!--                         :class="jiage === true ? 'acbutton' : 'dfbutton' " type="primary" round>1万元以上-->
<!--                    </div>-->
<!--                    <div style="margin-right: 10px;" @click="setjiage(false)"-->
<!--                         :class="jiage === false ? 'acbutton' : 'dfbutton' " type="primary" round>1万元以下-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="hotcity" style="margin-top: 10px;">项目标签</div>-->
<!--                <div class="citycon1" style="margin-top: 10px; justify-content: flex-start;">-->
<!--                  <div style="margin-right: 10px; margin-bottom: 10px;" @click="setbiaoqian('')"-->
<!--                       :class=" biaoqian === '' ? 'acbutton' : 'dfbutton' " type="primary" round>不 限-->
<!--                  </div>-->
<!--                  <div style="margin-right: 10px; margin-bottom: 10px;" :key="index" v-for="(item,index) in serviceList"-->
<!--                       @click="setbiaoqian(item.service_id)"-->
<!--                       :class=" biaoqian === item.service_id ? 'acbutton' : 'dfbutton' " type="primary" round>-->
<!--                    {{ item.name }}-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="hotcity" style="margin-top: 0px;">招募条件</div>-->
<!--                <div class="citycon1" style="margin-bottom: 20px;margin-top: 10px; justify-content: flex-start;">-->
<!--                  <div style="margin-right: 10px; margin-bottom: 10px;" @click="settiaojian('')"-->
<!--                       :class=" tiaojian === '' ? 'acbutton' : 'dfbutton' " type="primary" round>不 限-->
<!--                  </div>-->
<!--                  <div style="margin-right: 10px; margin-bottom: 10px;" @click="settiaojian(10)"-->
<!--                       :class=" tiaojian === 10 ? 'acbutton' : 'dfbutton' " type="primary" round>只招男-->
<!--                  </div>-->
<!--                  <div style="margin-right: 10px; margin-bottom: 10px;" @click="settiaojian(20)"-->
<!--                       :class=" tiaojian === 20 ? 'acbutton' : 'dfbutton' " type="primary" round>只招女-->
<!--                  </div>-->
<!--                  <div style="margin-right: 10px; margin-bottom: 10px;" @click="settiaojian(30)"-->
<!--                       :class=" tiaojian === 30 ? 'acbutton' : 'dfbutton' " type="primary" round>男满招女-->
<!--                  </div>-->
<!--                  <div style="margin-right: 10px; margin-bottom: 10px;" @click="settiaojian(40)"-->
<!--                       :class=" tiaojian === 40 ? 'acbutton' : 'dfbutton' " type="primary" round>女满招男-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div-->
<!--              style="display: flex;justify-content: space-between;margin-left: 15px;margin-right: 15px;margin-bottom: 20px;">-->
<!--              <van-button @click="saveSeach(true)" style="height: 35px; width: 45%;font-size: 14px;" type="primary"-->
<!--                          size="large" round>确认-->
<!--              </van-button>-->
<!--              <van-button @click="saveSeach(false)" style="height: 35px; width: 45%;font-size: 14px; color:#969799;"-->
<!--                          plain size="large" round>取消-->
<!--              </van-button>-->
<!--            </div>-->
<!--          </van-action-sheet>-->
<!--        </div>-->
<!--      </div>-->
<!--    </van-sticky>-->

    <!-- 项目列表组件 -->
    <van-pull-refresh style="margin-bottom: 60px;" v-model="isLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="itemcontent" @click="gotoDetials(item.goods_id)" v-for="(item,index) in list" :key="index">
          <div class="itembegin">
            <div class="item1" style="position: relative;">
              <van-image
                style="position: absolute;top: 0px;left: 0px;z-index: 8;"
                width="100%"
                height="135"
                :src="item.goods_image"
              />
              <div class="tiaojian" :style="getStatusRecColor(item.status_rec)">{{ getStatusRec(item.status_rec) }}
              </div>
<!--              <div class="city">{{ item.address.name }}</div>-->
<!--              <div class="city2">{{ gotoPy(item.address.name) }}</div>-->
            </div>
            <div class="item2">
              <div class="item2-2">
                <div class="name"> {{ item.goods_name }}</div>
                <!--                <div class="label" :style="getStatusColor(item.status)">{{getStatus(item.status)}}</div>-->
              </div>
              <div class="price" :style="buttonName === '我要报名'? 'margin-top:20px;' : ''">
                项目补助：{{ item.goods_price_max }}元
                <div class="label" :style="getStatusColor(item.status)">{{ getStatus(item.status) }}</div>
              </div>
              <div class="laberteam" :style="buttonName === '我要报名'? 'margin-top:10px;' : ''">
                <span style="margin-right: 5px;" v-for="(e,i) in item.service" :key="i">{{ e.service.name }}</span>
              </div>
              <div v-if="buttonName === '我要推荐'" class="laberteam">
                推荐费: 男{{item.line_price_max}}元  女{{item.line_price_min}}元
              </div>
              <div class="laberteam4" :style="buttonName === '我要报名'? 'margin-top:10px;' : ''">
                <div class="laberteam"> 开展中心：{{ item.goods_address_deail }}
                </div>
              </div>
            </div>
          </div>
          <van-divider style="margin-bottom: 10px;"></van-divider>
          <div  style="display: flex;justify-content: space-between;">
            <div style="font-size: 12px; margin-left: 10px;">体检时间：{{ getTime(item.start_time) }}</div>
            <div class="signBtn" style="margin-top: -4px;">
              <van-button round style="height: 30px;background-color: #8C7FFB;border: 1px solid #8C7FFB;margin-right: 10px;" type="info" size="small" @click="gotoDetials(item.goods_id)">
                {{ buttonName }}
              </van-button>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import {Toast} from 'vant'
import {bannerList, loginAuth, serviceAll} from "@/api/common";
import {List} from "@/api/goods";
import {getStatus, getStatusRec, getStatusColor, getStatusRecColor, getTime} from "@/utils/auth";
import myBMap from '@/utils/myBMap';
import wx from "_weixin-js-sdk@1.6.0@weixin-js-sdk";
import {pinyin} from 'pinyin-pro';
import {getAreList, getAreListIsT} from "../../api/common";

export default {
  name: 'healthcom',
  data() {
    return {
      loading: false,
      finished: false,
      isLoading: false,
      searchvalue: '',
      tijian: '',
      images: [
        'https://img01.yzcdn.cn/vant/apple-1.jpg',
        'https://img01.yzcdn.cn/vant/apple-2.jpg',
      ],
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      value: 3,
      count: 0,
      data: [],
      list: [],
      flist:[],
      city: '',
      cityold: '',
      serviceList: [],
      allcity: {},
      cityList: [],
      sortType: 'all',
      sortPrice: true,
      jiage: '',
      biaoqian: '',
      tiaojian: '',
      buttonName: "选择比对",
      isseacep :false,
      container:""
    };
  },
  created() {
    this.city = localStorage.getItem('city')
    this.getBannerList()
    this.getserviceAll()
    this.getCityList()
    this.getHotCityList()
    if (parseInt(localStorage.getItem('grade')) > 1) {
      this.buttonName = '选择比对'
    }
  },
  // mounted() {
  //   this.container = this.$refs.container;
  // },
  methods: {
    async getflist(){
      if(this.city == '' || this.city == null){
        Toast('请重新定位所在城市');
        this.getCity();
        return
      }
      this.show1 = true
      this.flist = []
      let res = await getAreList()
      if (res.status == 200) {
        let ic = 0
        for (let i = 0; i <  res.data.list.length; i++) {
          if(res.data.list[i]['name'] == this.city){

          }
          ic = i
        }
        for (let i = 0; i <  res.data.list.length; i++) {
          if(i < ic+6 && i> ic-6 && i !==ic){
            this.flist.push(res.data.list[i])
          }
        }
      }
    },
    async getHotCityList(){
      this.cityList = [{
        name: '全国',
      }]
      let res = await getAreListIsT()
      if (res.status == 200) {
        for (let i = 0; i <  res.data.list.length; i++) {
          this.cityList.push(res.data.list[i])
        }
      }
    },
    async getCityList(){
      this.allcity = {}
      let res = await getAreList()
      if (res.status == 200) {
        //获取所有索引
        for (let i = 0; i <  res.data.list.length; i++) {
          let indexA = this.gotoPy(res.data.list[i]['name']).substring(0,1).toUpperCase()
          this.allcity[indexA] = []
        }
        for (let i = 0; i <  res.data.list.length; i++) {
          let indexA = this.gotoPy(res.data.list[i]['name']).substring(0,1).toUpperCase()
          this.allcity[indexA].push({name:res.data.list[i]['name']})
        }
      }
    },
    gotoPy(val) {
      let py = pinyin(val, {toneType: 'none'})
      return py.split(" ").join('');
    },
    async saveSeach(val) {
      if (val) {
        //调用
        await this.onRefresh()
      } else {
        this.jiage = ''
        this.biaoqian = ''
        this.tiaojian = ''
      }
      this.show4 = false
    },
    async getserviceAll() {
      let res = await serviceAll()
      if (res.status == 200) {
        this.serviceList = res.data.list
      }
    },
    setjiage(val) {
      this.jiage = val
      this.isseacep = true
    },
    setbiaoqian(val) {
      this.biaoqian = val
      this.isseacep = true
    },
    settiaojian(val) {
      this.tiaojian = val
      this.isseacep = true
    },
    async setsrot() {
      this.sortType = 'all'
      this.sortPrice = !this.sortPrice
      this.isseacep = true
      await this.onRefresh()
    },
    async settijian(val) {
      this.tijian = val
      this.show3 = false
      this.isseacep = true
      await this.onRefresh()
    },
    async setCity(val) {
      if (val != '未知') {
        if (val == '全国') {
          this.cityold = ""
        } else {
          this.cityold = val
        }
        this.show2 = false
        this.show1 = false
        this.isseacep = true
        await this.onRefresh()
      }

    },
    async getCity() {
      let res = await loginAuth({url: location.href});
      let that = this
      wx.config({
        debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.data.appId, // 必填，公众号的唯一标识
        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
        signature: res.data.signature,// 必填，签名
        jsApiList: ['openLocation', 'getLocation'] // 必填，需要使用的JS接口列表
      });
      wx.ready(() => {
        wx.getLocation({
          type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: function (res) {
            myBMap.init().then(BMap => {
              let gc = new BMap.Geocoder();
              let pointAdd = new BMap.Point(res.longitude, res.latitude);
              gc.getLocation(pointAdd, function (rs) {
                that.city = rs.addressComponents.city;
                that.cityold = rs.addressComponents.city;
                localStorage.setItem('city', that.city)
              })
            })
          },
          cancel: function (res) {
            // console.log("用户取消授权")
            localStorage.setItem('dw', '111')
          }
        });
      });
    },
    getTime(val) {
      return getTime(val)
    },
    getStatusRecColor(val) {
      return getStatusRecColor(val)
    },
    getStatusRec(val) {
      return getStatusRec(val)
    },
    getStatusColor(val) {
      return getStatusColor(val)
    },
    getStatus(val) {
      return getStatus(val)
    },
    async onRefresh() {
      this.page = 1
      this.list = []
      await this.getGoodsList();
      this.isLoading = false;
    },
    async onLoad() {
      this.page++;
      await this.getGoodsList();
      this.loading = false;
      this.finished = true;
      if (this.list.length >= this.count) {
        this.finished = true;
      }
    },
    async getGoodsList() {
      let json = {
        page: this.page,
        type: 1,
        sortType: this.sortType,
        sortPrice: this.sortPrice
      }
      if (this.cityold !== "") {
        json.city = this.cityold
      }
      if (this.jiage !== "") {
        json.jiage = this.jiage
      }
      if (this.tiaojian !== "") {
        json.tiaojian = this.tiaojian
      }
      if (this.biaoqian !== "") {
        json.biaoqian = this.biaoqian
      }
      if (this.tijian !== "") {
        json.tijian = this.tijian
      }
      if (this.searchvalue !== "") {
        json.goodsName = this.searchvalue
      }

      let res = await List(json)
      this.count = res.data.list.total
      for (let i = 0; i < res.data.list.data.length; i++) {
        this.list.push(res.data.list.data[i])
      }
      if(this.isseacep && res.data.list.data.length<=0){
        Toast("无符合检索条件的项目，已为您自动推荐")
        //重置检索条件
        this.cityold = ""
        this.jiage = ""
        this.tiaojian = ""
        this.biaoqian = ""
        this.tijian = ""
        this.searchvalue = ""
        this.sortType = "all"
        this.onRefresh()
      }
    },
    async getBannerList() {
      let res = await bannerList()
      if (res.status == 200) {
        //赋值
        this.data = res.data.list;
      }
    },
    onChange(event) {
      this.setData({
        value: event.detail,
      });
    },
    async onSearch(val) {
      this.isseacep = true
      await this.onRefresh()
    },
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.show = false;
      Toast(item.name);
    },
    gotoDetials(id) {
      //父窗体回传id
      // this.$router.push({path: '/details', query: {id: id}})
      this.$emit('call-id',id)
    }
  },
}
</script>
<style scoped>
/*.van-button {*/
/*  width: 100%;*/
/*  height: 35px;*/
/*}*/
/deep/ .van-index-bar__sidebar {
  top: 60%;
}
.van-button--primary {
  color: #fff;
  background-color: #57CAC6;
  border: 1px solid #57CAC6;
}

.van-button--large {
  width: 100%;
  height: 45px;
}


.sticky1 {
  margin-top: 10px;
}

/*/deep/ .buxian .van-button--plain.van-button--primary {*/
/*  color: #57CAC6;*/
/*  border: 1px solid #57CAC6;*/
/*}*/
.active {
  background-color: #57CAC6;
  color: #fff;
}

/deep/ .citycon1 .van-rate__icon--full {
  color: #57CAC6;
}

.confirmBtnbuxian {
  margin-top: 50px;
  margin-bottom: 10px;
}

.begin {
  width: 100%;
  height: 100%;
}

.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  width: 100%;
}

.health {
  width: 100%;
  height: 100%;
  /* border: 1px solid red; */
}

.topsear {
  height: 100%;
  width: 100%;
  /* border: 1px solid black; */
}

.search {
  width: 100%;
}

/deep/ .van-search__content {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  padding-left: 12px;
  background-color: white;
  border-radius: 2px;
  border: 1px solid #57CAC6;
  border-radius: 35px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.van-search__action {
  padding: 0 15px;
  color: #323233;
  font-size: 10px;
  line-height: 34px;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  border: 1px solid #57CAC6;
  border-radius: 35px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  background-color: #57CAC6;
  color: white;
}

.van-search {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  box-sizing: border-box;
  padding: 5px 0;
}

/deep/ .van-field__left-icon .van-icon, .van-field__right-icon .van-icon {
  display: block;
  font-size: 16px;
  line-height: inherit;
  color: #57CAC6;
}

.swipe {
  width: 100%;
  height: 100%;
  margin-top: 5px;
  /* border: 1px solid red; */
}

.zhineng {
  /* margin-top: 10px; */
  width: 100%;
  height: 40px;
  line-height: 40px;
  background-color: white;
  padding-top: 10px;
  /* border: 1px solid red; */

}

/deep/ .van-sticky--fixed {
  position: fixed;
  top: 0;
  right: 20px;
  left: 20px;
  z-index: 99;
}

.beginzhineng {
  /* width: calc( 100% - 40px); */
  height: 30px;
  /* margin-left: 20px; */
  line-height: 30px;
  color: #101010;
  font-size: 14px;
  display: flex;
  justify-content: space-around;
}

.yyicon {
  margin-left: -5px;
  font-size: 14px;

}

.itemcontent {
  position: relative;
  width: 100%;
  height: 205px;
  border-radius: 4px;
  margin-bottom: 10px;
  padding-top: 5px;
  box-shadow: 0px 1px 40px -22px rgba(0, 0, 0, 0.4);
}

.itembegin {
  /*position: absolute;*/
  width: calc(100% - 20px);
  /* border: 1px solid red; */
  margin: 10px;
  margin-bottom: 15px;
  height: 135px;
  display: flex;
  justify-content: start;

}

.item1 {
  flex: 0.25;
  /* border: 1px solid red; */
  height: 135px;
  border-radius: 4px;
  background-image: url('../../assets/images/beijing.png');
  background-repeat: no-repeat;
  background-size: cover;
}

.item2 {
  flex: 0.75;
  /* border: 1px solid red; */
  height: 135px;
  /* padding-right: 10px; */
  margin-left: 10px;
}

.item2-2 {
  flex: 0.75;
  height: 25px;
  line-height: 25px;
  display: flex;
  justify-content: space-between;
}

.tiaojian {
  background-color: #FF7676;
  width: 50px;
  height: 20px;
  line-height: 20px;
  font-size: 10px;
  color: white;
  border-radius: 10px 0 10px 0;
}

.city {
  color: #101010;
  height: 20px;
  margin-top: 20px;
  line-height: 20px;
  font-size: 14px;

}

.city2 {
  color: #101010;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}

.name {
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  height: 25px;
  line-height: 20px;
}

.label {
  font-size: 12px;

  font-weight: 200;
  float: right;
  height: 25px;
  line-height: 25px;
  float: right;
}

.price {
  font-size: 14px;
  font-weight: 600;
  color: #FF7676;
  height: 26px;
  line-height: 26px;
  text-align: left;
  margin-top: 15px;
}

.laberteam {
  font-size: 12px;
  color: #101010;
  height: 24px;
  line-height: 24px;
  text-align: left;
}

.laberteam4 {
  display: flex;
  justify-content: space-between;
  /* border: 1px solid red; */
}

.signBtn {
  margin-top: -10px;
}

.van-button--info {
  color: #fff;
  background-color: #FF6764;
  border: 1px solid #FF6764;
}

.quyucontent {
  padding: 10px;
  /* border: 1px solid red; */
}

.citycon {
  /* width: calc(100% - 20px); */
  margin-left: 10px;
  height: 100%;
  text-align: left;
  /* border: 1px solid red; */
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}

.cityconpos {
  width: calc(100% - 20px);
  margin-left: 10px;
  height: 100%;
}

.citypos {
  width: 25%;
  /* height: 75px; */
  align-content: center;
  text-align: center;
  /* border: 1px solid red; */
  /* padding-right: 30px; */
}

.citypos1 {
  text-align: center;
  /* border: 1px solid red;   */
}

.citypos2 {
  text-align: center;
  margin-top: 10px;
  /* border: 1px solid red;   */
}

.citycon1 {
  height: 100%;
  text-align: left;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

/*.citycon1 .van-button--normal {*/
/*  padding: 0 0px;*/
/*  font-size: 14px;*/
/*}*/
.city1 {
  /* height: 75px; */
  /* border: 1px solid red; */
}

.van-action-sheet {
  max-height: 95%;
}

.van-action-sheet__header {
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  font-weight: 800;
  font-size: 16px;
  line-height: 48px;
  text-align: center;
}

.van-action-sheet__close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 16px;
  color: #4A4A4A;
  font-size: 18px;
  line-height: inherit;
}

.quyu {
  color: #AAAAAA;
}

.confirmBtn {
  margin-top: 20px;
  margin-bottom: 10px;
}

.quxiao .confirmBtn1.van-button--primary {
  color: #fff;
  background-color: #07c160;
  /* border: 1px solid white; */
}

.citychange .van-action-sheet__header[data-v-46d6aa14] {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  font-weight: 800;
  font-size: 14px;
  line-height: 48px;
  text-align: left;
  margin-left: 20px;
}

.citychange .quyu {
  text-align: left;
  margin-left: 20px;
  /* border: 1px solid red; */
}

.hotcity {
  text-align: left;
  color: #AAAAAA;
  margin-left: -5px;
  margin-top: 20px;
  /* line-height: 40px;
  height: 40px; */
  /* border: 1px solid red; */
}

.location {
  color: #AAAAAA;
}

.quanguo {
  position: relative;
  width: 100%;
  height: 100%;
  height: 300px;
  margin-top: 20px;
  overflow: auto;
}

.van-index-bar {
  text-align: left;
}

.acbutton {
  padding: 0 20px;
  height: 30px;
  line-height: 32px;
  font-size: 12px;
  background-color: #fff;
  color: #57CAC6;
  border: 1px solid #57CAC6;
  border-radius: 30px;
}

.dfbutton {
  padding: 0 20px;
  height: 30px;
  line-height: 32px;
  font-size: 12px;
  background-color: #F7F7F7;
  color: rgba(170, 170, 170, 100);
  border: 1px solid #F7F7F7;
  border-radius: 30px;
}

.dfbutton:active {
  background-color: #fff;
  color: #57CAC6;
  border: 1px solid #57CAC6;
}

.acbutton:active {
  background-color: #fff;
  color: #57CAC6;
  border: 1px solid #57CAC6;
}

/*.van-button--plain {*/
/*  background-color: #fff;*/
/*  color: #57CAC6;*/
/*  border: 1px solid #57CAC6;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/views/item/healthcom.vue